/* eslint-disable */
// tslint:disable
/**
 * Контракты сервиса Учи.Ответы
 * Контракты сервиса Учи.Ответы
 *
 * OpenAPI spec version: 0.0.3-rc.7
 * Contact: team@uchi.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  FetchAPI,
  FetchArgs,
  BaseAPI,
  RequiredError,
  defaultFetch,
} from './runtime';
import { Api } from './models';

export type FactoryFunction<T> = (
  configuration?: Configuration,
  basePath?: string,
  fetch?: FetchAPI,
) => T;

/**
 * MarusiaApi - fetch parameter creator
 * @export
 */
export const MarusiaApiFetchParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <p>Получение данных о ответе от Маруси (если есть на этот вопрос)</p>
     * @summary Данные ответа от Маруси
     * @param {string} slug <p>slug вопроса</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarusiaData(slug: string, options: RequestInit = {}): FetchArgs {
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          'slug',
          'Required parameter slug was null or undefined when calling getMarusiaData.',
        );
      }
      let localVarPath = `/otvety/api/questions/{slug}/marusia`.replace(
        '{slug}',
        encodeURIComponent(String(slug)),
      );
      const localVarPathQueryStart = localVarPath.indexOf('?');
      const localVarRequestOptions: RequestInit = Object.assign(
        { method: 'GET' },
        options,
      );
      const localVarHeaderParameter: Headers = options.headers
        ? new Headers(options.headers)
        : new Headers();
      const localVarQueryParameter = new URLSearchParams(
        localVarPathQueryStart !== -1
          ? localVarPath.substring(localVarPathQueryStart + 1)
          : '',
      );
      if (localVarPathQueryStart !== -1) {
        localVarPath = localVarPath.substring(0, localVarPathQueryStart);
      }

      localVarRequestOptions.headers = localVarHeaderParameter;

      const localVarQueryParameterString = localVarQueryParameter.toString();
      if (localVarQueryParameterString) {
        localVarPath += '?' + localVarQueryParameterString;
      }
      return {
        url: localVarPath,
        options: localVarRequestOptions,
      };
    },
    /**
     * <p>Жалоба на ответ от Маруси по id ответа (возвращает true - если жалоба успешно отправлена, false - если этот пользователь уже жаловался на этот ответ)</p>
     * @summary Жалоба на ответ от Маруси
     * @param {string} slug <p>slug вопроса</p>
     * @param {string} xCsrfToken <p>OTVETY-CSRF-TOKEN</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarusiaComplain(
      slug: string,
      xCsrfToken: string,
      options: RequestInit = {},
    ): FetchArgs {
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          'slug',
          'Required parameter slug was null or undefined when calling postMarusiaComplain.',
        );
      }
      // verify required parameter 'xCsrfToken' is not null or undefined
      if (xCsrfToken === null || xCsrfToken === undefined) {
        throw new RequiredError(
          'xCsrfToken',
          'Required parameter xCsrfToken was null or undefined when calling postMarusiaComplain.',
        );
      }
      let localVarPath = `/otvety/api/questions/{slug}/marusia/complain`.replace(
        '{slug}',
        encodeURIComponent(String(slug)),
      );
      const localVarPathQueryStart = localVarPath.indexOf('?');
      const localVarRequestOptions: RequestInit = Object.assign(
        { method: 'POST' },
        options,
      );
      const localVarHeaderParameter: Headers = options.headers
        ? new Headers(options.headers)
        : new Headers();
      const localVarQueryParameter = new URLSearchParams(
        localVarPathQueryStart !== -1
          ? localVarPath.substring(localVarPathQueryStart + 1)
          : '',
      );
      if (localVarPathQueryStart !== -1) {
        localVarPath = localVarPath.substring(0, localVarPathQueryStart);
      }

      // authentication cookieAuth required
      if (xCsrfToken !== undefined) {
        localVarHeaderParameter.append('X-CSRF-TOKEN', String(xCsrfToken));
      }

      localVarRequestOptions.headers = localVarHeaderParameter;

      const localVarQueryParameterString = localVarQueryParameter.toString();
      if (localVarQueryParameterString) {
        localVarPath += '?' + localVarQueryParameterString;
      }
      return {
        url: localVarPath,
        options: localVarRequestOptions,
      };
    },
    /**
     * <p>Спасибо на ответ от Маруси по id ответа (возвращает true - если лайк успешно отправлен, false - если этот пользователь уже лайкал ответ)</p>
     * @summary Лайк на ответ от Маруси
     * @param {string} slug <p>slug вопроса</p>
     * @param {string} xCsrfToken <p>OTVETY-CSRF-TOKEN</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarusiaVote(
      slug: string,
      xCsrfToken: string,
      options: RequestInit = {},
    ): FetchArgs {
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          'slug',
          'Required parameter slug was null or undefined when calling postMarusiaVote.',
        );
      }
      // verify required parameter 'xCsrfToken' is not null or undefined
      if (xCsrfToken === null || xCsrfToken === undefined) {
        throw new RequiredError(
          'xCsrfToken',
          'Required parameter xCsrfToken was null or undefined when calling postMarusiaVote.',
        );
      }
      let localVarPath = `/otvety/api/questions/{slug}/marusia/vote`.replace(
        '{slug}',
        encodeURIComponent(String(slug)),
      );
      const localVarPathQueryStart = localVarPath.indexOf('?');
      const localVarRequestOptions: RequestInit = Object.assign(
        { method: 'POST' },
        options,
      );
      const localVarHeaderParameter: Headers = options.headers
        ? new Headers(options.headers)
        : new Headers();
      const localVarQueryParameter = new URLSearchParams(
        localVarPathQueryStart !== -1
          ? localVarPath.substring(localVarPathQueryStart + 1)
          : '',
      );
      if (localVarPathQueryStart !== -1) {
        localVarPath = localVarPath.substring(0, localVarPathQueryStart);
      }

      // authentication cookieAuth required
      if (xCsrfToken !== undefined) {
        localVarHeaderParameter.append('X-CSRF-TOKEN', String(xCsrfToken));
      }

      localVarRequestOptions.headers = localVarHeaderParameter;

      const localVarQueryParameterString = localVarQueryParameter.toString();
      if (localVarQueryParameterString) {
        localVarPath += '?' + localVarQueryParameterString;
      }
      return {
        url: localVarPath,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarusiaApi - functional programming interface
 * @export
 */
export const MarusiaApiFp = function (configuration?: Configuration) {
  return {
    /**
     * <p>Получение данных о ответе от Маруси (если есть на этот вопрос)</p>
     * @summary Данные ответа от Маруси
     * @param {string} slug <p>slug вопроса</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarusiaData(
      slug: string,
      options?: RequestInit,
    ): (
      fetch?: FetchAPI,
      basePath?: string,
    ) => Promise<Api.GetMarusiaData200Response | null> {
      const localVarFetchArgs = MarusiaApiFetchParamCreator(configuration).getMarusiaData(
        slug,
        options,
      );
      return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
        return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(
          (response) => {
            const contentType = response.headers.get('Content-Type');
            const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

            if (response.status === 200) {
              if (mimeType === 'application/json') {
                return response.json() as any;
              }
              throw response;
            }
            throw response;
          },
        );
      };
    },
    /**
     * <p>Жалоба на ответ от Маруси по id ответа (возвращает true - если жалоба успешно отправлена, false - если этот пользователь уже жаловался на этот ответ)</p>
     * @summary Жалоба на ответ от Маруси
     * @param {string} slug <p>slug вопроса</p>
     * @param {string} xCsrfToken <p>OTVETY-CSRF-TOKEN</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarusiaComplain(
      slug: string,
      xCsrfToken: string,
      options?: RequestInit,
    ): (
      fetch?: FetchAPI,
      basePath?: string,
    ) => Promise<Api.PostMarusiaComplain200Response> {
      const localVarFetchArgs = MarusiaApiFetchParamCreator(
        configuration,
      ).postMarusiaComplain(slug, xCsrfToken, options);
      return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
        return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(
          (response) => {
            const contentType = response.headers.get('Content-Type');
            const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

            if (response.status === 200) {
              if (mimeType === 'application/json') {
                return response.json() as any;
              }
              throw response;
            }
            throw response;
          },
        );
      };
    },
    /**
     * <p>Спасибо на ответ от Маруси по id ответа (возвращает true - если лайк успешно отправлен, false - если этот пользователь уже лайкал ответ)</p>
     * @summary Лайк на ответ от Маруси
     * @param {string} slug <p>slug вопроса</p>
     * @param {string} xCsrfToken <p>OTVETY-CSRF-TOKEN</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarusiaVote(
      slug: string,
      xCsrfToken: string,
      options?: RequestInit,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Api.PostMarusiaVote200Response> {
      const localVarFetchArgs = MarusiaApiFetchParamCreator(
        configuration,
      ).postMarusiaVote(slug, xCsrfToken, options);
      return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
        return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(
          (response) => {
            const contentType = response.headers.get('Content-Type');
            const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

            if (response.status === 200) {
              if (mimeType === 'application/json') {
                return response.json() as any;
              }
              throw response;
            }
            throw response;
          },
        );
      };
    },
  };
};

/**
 * MarusiaApi - factory interface
 * @export
 */
export const MarusiaApiFactory: FactoryFunction<MarusiaApi> = function (
  configuration?: Configuration,
  basePath?: string,
  fetch?: FetchAPI,
) {
  return new MarusiaApi(configuration, basePath, fetch);
};

/**
 * MarusiaApi - object-oriented interface
 * @export
 * @class MarusiaApi
 * @extends {BaseAPI}
 */
export class MarusiaApi extends BaseAPI {
  /**
   * <p>Получение данных о ответе от Маруси (если есть на этот вопрос)</p>
   * @summary Данные ответа от Маруси
   * @param {string} slug <p>slug вопроса</p>
   * @param {RequestInit} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getMarusiaData(slug: string, options?: RequestInit) {
    return MarusiaApiFp(this.configuration).getMarusiaData(slug, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   * <p>Жалоба на ответ от Маруси по id ответа (возвращает true - если жалоба успешно отправлена, false - если этот пользователь уже жаловался на этот ответ)</p>
   * @summary Жалоба на ответ от Маруси
   * @param {string} slug <p>slug вопроса</p>
   * @param {string} xCsrfToken <p>OTVETY-CSRF-TOKEN</p>
   * @param {RequestInit} [options] Override http request option.
   * @throws {RequiredError}
   */
  public postMarusiaComplain(slug: string, xCsrfToken: string, options?: RequestInit) {
    return MarusiaApiFp(this.configuration).postMarusiaComplain(
      slug,
      xCsrfToken,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   * <p>Спасибо на ответ от Маруси по id ответа (возвращает true - если лайк успешно отправлен, false - если этот пользователь уже лайкал ответ)</p>
   * @summary Лайк на ответ от Маруси
   * @param {string} slug <p>slug вопроса</p>
   * @param {string} xCsrfToken <p>OTVETY-CSRF-TOKEN</p>
   * @param {RequestInit} [options] Override http request option.
   * @throws {RequiredError}
   */
  public postMarusiaVote(slug: string, xCsrfToken: string, options?: RequestInit) {
    return MarusiaApiFp(this.configuration).postMarusiaVote(
      slug,
      xCsrfToken,
      options,
    )(this.fetch, this.basePath);
  }
}
/**
 * QuestionApi - fetch parameter creator
 * @export
 */
export const QuestionApiFetchParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <p>Получение всей информации о вопросе по его слагу</p>
     * @summary Информация о вопросе
     * @param {string} slug <p>slug вопроса</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion(slug: string, options: RequestInit = {}): FetchArgs {
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          'slug',
          'Required parameter slug was null or undefined when calling getQuestion.',
        );
      }
      let localVarPath = `/otvety/api/questions/{slug}`.replace(
        '{slug}',
        encodeURIComponent(String(slug)),
      );
      const localVarPathQueryStart = localVarPath.indexOf('?');
      const localVarRequestOptions: RequestInit = Object.assign(
        { method: 'GET' },
        options,
      );
      const localVarHeaderParameter: Headers = options.headers
        ? new Headers(options.headers)
        : new Headers();
      const localVarQueryParameter = new URLSearchParams(
        localVarPathQueryStart !== -1
          ? localVarPath.substring(localVarPathQueryStart + 1)
          : '',
      );
      if (localVarPathQueryStart !== -1) {
        localVarPath = localVarPath.substring(0, localVarPathQueryStart);
      }

      localVarRequestOptions.headers = localVarHeaderParameter;

      const localVarQueryParameterString = localVarQueryParameter.toString();
      if (localVarQueryParameterString) {
        localVarPath += '?' + localVarQueryParameterString;
      }
      return {
        url: localVarPath,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuestionApi - functional programming interface
 * @export
 */
export const QuestionApiFp = function (configuration?: Configuration) {
  return {
    /**
     * <p>Получение всей информации о вопросе по его слагу</p>
     * @summary Информация о вопросе
     * @param {string} slug <p>slug вопроса</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion(
      slug: string,
      options?: RequestInit,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetQuestion200Response> {
      const localVarFetchArgs = QuestionApiFetchParamCreator(configuration).getQuestion(
        slug,
        options,
      );
      return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
        return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(
          (response) => {
            const contentType = response.headers.get('Content-Type');
            const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

            if (response.status === 200) {
              if (mimeType === 'application/json') {
                return response.json() as any;
              }
              throw response;
            }
            if (response.status === 404) {
              if (mimeType === 'application/json') {
                throw response;
              }
              throw response;
            }
            throw response;
          },
        );
      };
    },
  };
};

/**
 * QuestionApi - factory interface
 * @export
 */
export const QuestionApiFactory: FactoryFunction<QuestionApi> = function (
  configuration?: Configuration,
  basePath?: string,
  fetch?: FetchAPI,
) {
  return new QuestionApi(configuration, basePath, fetch);
};

/**
 * QuestionApi - object-oriented interface
 * @export
 * @class QuestionApi
 * @extends {BaseAPI}
 */
export class QuestionApi extends BaseAPI {
  /**
   * <p>Получение всей информации о вопросе по его слагу</p>
   * @summary Информация о вопросе
   * @param {string} slug <p>slug вопроса</p>
   * @param {RequestInit} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getQuestion(slug: string, options?: RequestInit) {
    return QuestionApiFp(this.configuration).getQuestion(slug, options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value: Date | string | undefined): string | undefined {
  if (value instanceof Date) {
    return value.toISOString();
  } else if (typeof value === 'string') {
    return value;
  } else {
    return undefined;
  }
}
